import { fabric } from 'fabric';
import cloneDeep from 'lodash-es/cloneDeep';

const LudusPath = fabric.util.createClass(fabric.Path, {
  type: 'ludusPath',
  includeDefaultValues: true,
  shadow: 0,
  strokeWidth: 0,
  clipTo: 0,
  transformMatrix: 0,
  editable: true,
  evented: true,
  selectable: true,
  strokeStyle: 'solid',
  perPixelTargetFind: false,
  styles: 0,
  stroke: false,
  strokeDashArray: [0, 0],
  lockUniScaling: false,
  strokeLineCap: 'round',

  initialize(options = {}) {
    this.initialized = false;

    let _options = cloneDeep(options);
    const _path =
      typeof _options.path === 'string'
        ? JSON.parse(_options.path)
        : _options.path;

    _options = {
      ..._options,
      path: _path,

      strokeWidth: options.strokeWidth || 0,
      strokeLineCap: 'round',
      ludus: { ...options.ludus, type: 'path' },
    };
    // some icons from iconsScout (but not only) contains hidden objects...
    // Resulting in very very big luds Pathgroup.
    // It's safe to remove this hidden objects (that we consider as a bug from the third party
    const path = _options.path;
    this.callSuper('initialize', path, _options);
    this.initialized = true;
  },

  applyGroupScale() {
    if (this.group) {
      const scale =
        this.group.scaleX > this.group.scaleY
          ? this.group.scaleY
          : this.group.scaleX;
      this.set({ strokeWidth: this.strokeWidth * scale });
    }
  },

  _set(key, value) {
    this.callSuper('_set', key, value);

    if (!this.initialized) {
      return this;
    }

    return this;
  },
  _renderStroke(ctx) {
    if (!this.stroke || !this.strokeWidth || this.strokeWidth === 0) {
      return;
    }

    if (this.shadow && !this.shadow.affectStroke) {
      this._removeShadow(ctx);
    }
    // // Change from Fabric official build
    // // don't deforom stroke if not grouped inside a pathGroup (svg)
    ctx.save();
    if (!this.group || this.group.type !== 'ludusPathGroup') {
      const transformMatrix = this.calcTransformMatrix();
      const invertMatrix = fabric.util.invertTransform(transformMatrix);
      ctx.transform(...invertMatrix);
    }
    this._setLineDash(ctx, this.strokeDashArray, this._renderDashedStroke);
    this._applyPatternGradientTransform(ctx, this.stroke);

    ctx.stroke();
    ctx.restore();
  },

  toObject(propertiesToInclude = []) {
    return fabric.util.object.extend(
      fabric.Object.prototype.toObject.call(this, propertiesToInclude),
      {
        path: JSON.stringify(this.path),
      },
    );
  },
});

LudusPath.fromObject = function fromObject(object, callback) {
  const options = fabric.util.object.clone(object, true);

  if (typeof object.sourcePath === 'string') {
    const pathUrl = object.sourcePath;
    fabric.loadSVGFromURL(pathUrl, elements => {
      const path = elements[0];
      path.setOptions(object);
      callback && callback(new LudusPath(options));
    });
  } else {
    callback && callback(new LudusPath(options));
  }
};

LudusPath.fromElement = function(element, callback, options) {
  const extend = fabric.util.object.extend;
  const parsedAttributes = fabric.parseAttributes(
    element,
    fabric.Path.ATTRIBUTE_NAMES,
  );
  parsedAttributes.fromSVG = true;

  callback(
    new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)), // eslint-disable-line no-undef
  );
};

export default LudusPath;
